<app-navbar></app-navbar>
<section class="question-creator-page py-4 py-xl-5 main-section-body-content">
    <div class="container">
        <div class="page-header mb-4">
            <h2>Question Creator</h2>
            <p>Define metadata, craft question content, manage media, and configure answer options.</p>
        </div>
        <div class="row">
            <div class="col-12 mb-5">
                <mat-card class="section-card">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="section-title">Question Metadata</h4>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center">
                            <mat-form-field appearance="fill">
                            <mat-label>Select Level</mat-label>
                            <mat-select [(ngModel)]="gradeSelected">
                                <mat-option *ngFor="let grade of grades" [value]="grade.value">
                                {{grade.viewValue}}
                                </mat-option>
                            </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center">
                            <mat-form-field appearance="fill">
                                <mat-label>Select Question Type</mat-label>
                                <mat-select (selectionChange)="onQuestionTypeChanged($event.value)" [(ngModel)]="questionTypeSelected">
                                    <mat-option *ngFor="let qt of questionTypes" [value]="qt.typeId">
                                      {{qt.type}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center">
                            <mat-form-field appearance="fill">
                                <mat-label>Select Question Timeline</mat-label>
                                <mat-select [(ngModel)]="timelineSelected">
                                    <mat-option *ngFor="let time of times" [value]="time.value">
                                    {{time.viewValue}}
                                    </mat-option>
                                </mat-select>
                                </mat-form-field>
                        </div>
                        <div class="col-md-6 col-lg-3 text-center">
                            <mat-form-field appearance="fill">
                                <mat-label>Select Question SubType</mat-label>
                                <mat-select  [(ngModel)]="subTypeSelected">
                                    <mat-option *ngFor="let qst of subTypes" [value]="qst.subTypeId">
                                    {{qst.subType}}
                                    </mat-option>
                                </mat-select>
                                </mat-form-field>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="col-12 mb-5">
                <mat-card class="section-card">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="section-title">Question Body</h4>
                        </div>
                        <div class="col-12 mb-3">
                            <mat-form-field class="w-100">
                                <mat-label>Title</mat-label>
                                <input matInput placeholder="Question Title" [(ngModel)]="questionTitle">
                              </mat-form-field>
                        </div>
                        <div class="col-12 text-center">
                            <angular-editor  [placeholder]="'Start Question here...'" [(ngModel)]="questionContent" class="custom-question-text-editor" ></angular-editor>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="col-12 mb-5">
                <mat-card class="section-card">
                    <div *ngIf="files != null && files.length > 0">
                        <h5 class="selected-file-text mb-4">Selected Files:</h5>
                        <div class="d-grid selected-file-grid mb-4">
                            <div *ngFor="let file of files" class="file-box d-flex align-items-center justify-content-between w-100">
                                <div class="file-cap">{{file.name}}</div>
                                <mat-icon class="delete-icon transition-all-03 cursor-pointer" (click)="removeFile(file.name)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="w-100">
                        <div class="custom-upload">
                            <button class="custom-uplaod-btn app-btn app-btn-secondary" type="button">Upload a file</button>
                            <input class="custom-uplaod-input cursor-pointer" type="file" name="myfile" (change)="onFileAdd($event)" multiple/>
                        </div>
                    </div>
                    <div class="w-100 mt-3">
                        <button class="text-center app-btn app-btn-primary" mat-flat-button color="primary" (click)="fileUpload()">File Upload</button>
                    </div>
                </mat-card>
            </div>
            <div class="col-12 mb-5">
                <mat-card class="section-card">
                    <div class="w-100">
                        <h4 class="section-title">Uploaded Files</h4>
                    </div>
                    <div class="w-100 uploaded-files-grid">
                        <div class="w-100 uploaded-files-col d-flex align-items-center gap-2"  *ngFor="let qsMedia of questionMediaUrl">
                            <img class="img-size" src='{{qsMedia}}'>
                            <div class="d-flex align-items-center gap-2 ms-auto">
                                <button mat-fab color="warn" (click)="removeImage(qsMedia)" aria-label="Example icon button with a delete icon" class="d-flex align-items-center justify-content-center transition-all-03 cursor-pointer uploaded-icon">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <button mat-icon-button color="accent" aria-label="Example icon button with a menu icon" class="d-flex align-items-center justify-content-center transition-all-03 cursor-pointer uploaded-icon">
                                    <mat-icon>menu</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="col-12 mb-5">
                <mat-card class="section-card">
                    <div class="w-100">
                        <h4 class="section-title">Create Options</h4>
                    </div>
                    <div class="w-100 create-options-wrap">
                        <button mat-raised-button color="primary" class="app-btn app-btn-primary mb-4" (click)="openModal()">Create Option</button>
                        <div class="create-options-scroll-view">
                            <div class="row w-100 mb-3">
                                <div class="col-4">
                                   <h5 class="mb-0">Option Text</h5>
                                </div>
                                <div class="col-4">
                                  <h5 class="mb-0"> Media </h5>
                                </div>
                                <div class="col-4">
                                   <h5 class="mb-0"> Answer : true/false </h5>
                                </div>
                            </div>
                            <div *ngFor="let option of optionsArray" class="row w-100 mb-2 align-items-center">
                                <div class="col-4">
                                    <h5 class="mb-0">{{option.text}}</h5>
                                    <small *ngIf="option.metadata?.behaviorCategory" class="text-muted">Category: {{option.metadata.behaviorCategory}}</small>
                                </div>
                                <div class="col-4">
                                    <div class="create-options-img-size-wrap">
                                        <img src='{{option.mediaUrl}}' class="img-size">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="d-flex align-items-lg-center flex-column flex-lg-row gap-md-2">
                                        <h5 class="mb-0">{{option.answer}}</h5>
                                        <div class="d-flex align-items-center gap-2 create-options-btn-wrap">
                                            <button class="option-action-btn option-edit-btn" mat-stroked-button color="accent" (click)="editOption(option)">
                                              <mat-icon class="text-center transition-all-03 cursor-pointer uploaded-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M12.8995 6.85453L17.1421 11.0972L7.24264 20.9967H3V16.754L12.8995 6.85453ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z"></path></svg>
                                              </mat-icon>
                                            </button>   
                                            <button class="option-action-btn option-delete-btn" mat-stroked-button color="warn" (click)="dropOption(option.id)">
                                              <mat-icon class="text transition-all-03 cursor-pointer uploaded-icon">delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="col-12">
                <mat-card class="section-card">
                    <div class="w-100">
                        <h4 class="section-title">Save Question</h4>
                    </div>
                    <button mat-raised-button color="primary" class="app-btn app-btn-success" (click)="onSubmit()">Submit Question</button>
                </mat-card>
            </div>
        </div>
    </div>
</section>


 <div class="row mx-0">
    <div class="col-md-12 px-0">
        <app-footer></app-footer>
    </div>
 </div>

 <!-- Modal -->
 <div class="modal question-create-option-modal align-items-center justify-content-center" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
    <div class="modal-dialog modal-dialog-centered w-100 mx-auto" role="document">
          <div class="modal-content">
                <div class="modal-header">
                      <h4 class="mid-title">Create Option</h4>
                      <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()"><span aria-hidden="true">&times;</span></button>
                    </div>
                <div class="modal-body">
                    <div class="mb-1">
                        <h3 class="fw-medium mb-0">Option Value</h3>
                        <mat-form-field class="w-100">
                         <mat-label>Option Value</mat-label>
                         <input matInput placeholder="Option Value" [(ngModel)]="optionText">
                       </mat-form-field>
                    </div>
                    <div class="mb-3">
                        <h3 class="fw-medium mb-1">Option Image</h3>
                        <div class="custom-upload">
                           <button class="custom-uplaod-btn">Upload a file</button>
                           <input #optionInput class="custom-uplaod-input cursor-pointer" type="file" name="myfile" (click)="optionInput.value = null"  (change)="optionMediaUrlFn($event)"/>
                       </div>
                    </div>
                    
                    <!-- Behavior Category Dropdown (replaces Option Context for behavior questions) -->
                    <div class="mb-3" *ngIf="requireOptionContext">
                        <h3 class="fw-medium mb-1">Behavior Category</h3>
                        <mat-form-field class="w-100" appearance="fill">
                          <mat-label>Select Behavior Category</mat-label>
                          <mat-select [(ngModel)]="selectedBehaviorCategory" [disabled]="isLoadingCategories">
                            <mat-option *ngFor="let category of behaviorCategories" [value]="category.categoryId">
                              {{category.categoryName}}
                            </mat-option>
                          </mat-select>
                          <mat-hint *ngIf="isLoadingCategories">Loading categories...</mat-hint>
                        </mat-form-field>
                      </div>
                      
                    <div>
                        <h3 class="fw-medium mb-1">Is this answer?</h3>
                        <section class="example-section">
                          <mat-checkbox  [(ngModel)]="isChecked" >Right Answer</mat-checkbox>
                        </section>
                    </div>
                </div>
                <div class="modal-footer gap-2">
                      <button class="app-btn app-btn-danger" type="button" (click)="onCloseHandled()">Close</button>
                      <button class="app-btn app-btn-success" type="button" (click)="addOption()">Save</button>
               </div>
       </div>
        </div>
</div>
